import Pagination from '@material-ui/lab/Pagination';

import IndividualCircularLoader from '../../../../components/Loader/IndividualCircularLoader';
import { APIStatus } from '../../../../services/axiosEnums';
import AdCard from './adCard/AdCard';
import styles from './adCardContainer.module.scss';
import AdCardDisplayParams from './AdCardDisplayParams';
import LoadErrorMessage from './LoadErrorMessage';
import usePiecework from '../../../piecework/usePiecework';
import Button from '../../../../components/Assets/Button';
import { useNavigate } from 'react-router-dom';
import { appManagerActions } from '../../../../store/appManager/actions';
import { useAppDispatch } from '../../../../App/redux/store';
import { isEmpty } from 'lodash';

export interface IOnPageChangeProps {
  page: number;
}
interface IAdCardContainerProps {
  ads: IApiState<Ads | null>;
  type: 'ads' | 'activeResearches' | 'adStudies';
  adsPagination: AdPaginationDatas;
  onPaginationChange: (datas: AdPaginationDatas) => void;
  onCheckAd: (ad: Ad) => void;
  onCardClick: (Ad: Ad) => void;
  extendedDisplayParams?: React.ReactNode;
  checkedIds: string[];
}
const AdCardContainer = ({
  ads,
  type,
  onPaginationChange,
  onCheckAd,
  extendedDisplayParams = null,
  checkedIds,
  onCardClick,
  adsPagination,
}: IAdCardContainerProps) => {
  const { cities } = usePiecework({ loadMarketResearch: true });
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handlePageChange = (page: number) => {
    onPaginationChange({ ...adsPagination, page });
  };

  const handleDisplayParamsChange = (datas: AdPaginationDatas) => {
    onPaginationChange({ ...adsPagination, ...datas });
  };

  const handleModifyParamsClick = () => {
    navigate('/mon-compte');
    dispatch(appManagerActions.selectedAccountTab.set(2));
  };

  return (
    <div className={styles.adCardContainer}>
      <AdCardDisplayParams
        onDisplayChange={handleDisplayParamsChange}
        displayDatas={adsPagination}
        extendedDisplayParams={extendedDisplayParams}
      />

      {ads.apiStatus === APIStatus.PENDING ? (
        <IndividualCircularLoader size={200} />
      ) : ads.apiStatus === APIStatus.IDLE && ads && ads.result?.length === 0 ? (
        <p className={styles.noContent}>Aucune opportunité Trouvée</p>
      ) : isEmpty(cities) ? (
        <div className={styles.emptyPigeContainer}>
          <p>
            Votre pige n&apos;est associée à aucune commune.
            <br />
            Veuillez modifier ses paramètres dans la page Mon compte.
          </p>
          <Button
            btnType="button"
            btnContent="Modifier les paramètres de la pige"
            primary
            handleClick={handleModifyParamsClick}
          />
        </div>
      ) : ads.apiStatus === APIStatus.REJECTED ? (
        <LoadErrorMessage />
      ) : (
        <>
          <section className={styles.container}>
            {ads.result?.map((ad) => {
              return (
                <AdCard
                  ad={ad}
                  key={ad.idIri}
                  type={type}
                  isNew={false}
                  onCheckAd={() => onCheckAd(ad)}
                  checked={checkedIds.includes(ad.idIri)}
                  onCardClick={() => onCardClick(ad)}
                />
              );
            })}
          </section>
          {adsPagination.totalAds > adsPagination.itemsPerPage && (
            <Pagination
              page={adsPagination.page}
              count={Math.ceil(adsPagination.totalAds / adsPagination.itemsPerPage)}
              onChange={(evt, page) => handlePageChange(page)}
              variant="outlined"
            />
          )}
        </>
      )}
    </div>
  );
};

export default AdCardContainer;
